<button [matMenuTriggerFor]="menu" class="mb-2">
    <img  [src]="currentFlag" class="flag-svg" />
</button>
<mat-menu #menu>
    <button mat-menu-item *ngFor="let l of changeLangs"
        (click)="changeLanguage(l.lang)">
        <img  [src]="l.flag" class="flag-svg" />
        <span>{{l.label}}</span>
    </button>
</mat-menu>
